<template>
  <main>
    <div class="container">
      <div class="row">
        <div class="col-full">
          <h1 class="heading-xl">
            {{ $t('themeSettings.heading') }}
          </h1>
        </div>
        <div class="col-full">
          <al-radio-group
            v-model="selectedTheme"
            data-test="theme-options"
            :items="themeModes"
            card-view
            name="theme-modes"
            @input="selectHandler" />
        </div>
      </div>
      <div class="row-vertical-align-bottom">
        <div class="col-full align-center">
          <back-button v-analytics:click="$EVENTS.GO_BACK_BUTTON" :location="backButtonRoute">
            {{ $t('button.goBack') }}
          </back-button>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { AlRadioGroup, Theme, getCurrentTheme, setTheme } from '@mc-alberta/alcapone'
import { mapActions } from 'vuex'
import BackButton from '@/components/BackButton'
import { ROUTES } from '@/constants'

export default {
  name: ROUTES.THEME_SETTINGS,
  components: { AlRadioGroup, BackButton },
  data() {
    return {
      backButtonRoute: { name: ROUTES.SETTINGS },
      currentTheme: getCurrentTheme()
    }
  },
  computed: {
    themeModes() {
      return [
        { label: this.$t('themeSettings.lightMode'), value: Theme.LIGHT },
        { label: this.$t('themeSettings.darkMode'), value: Theme.DARK },
        {
          label: this.$t('themeSettings.systemMode'),
          subtext: this.$t('themeSettings.systemModeDescription'),
          value: Theme.SYSTEM
        }
      ]
    },
    selectedTheme: {
      get() {
        return this.currentTheme
      },
      set(theme) {
        setTheme(theme)
        this.currentTheme = theme
      }
    }
  },
  methods: {
    ...mapActions(['setAppTheme']),
    selectHandler() {
      const appTheme = getCurrentTheme()
      this.setAppTheme(appTheme)
      this.$analytics.track(this.$EVENTS.CHANGE_THEME)
    }
  }
}
</script>
